import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DeviceProvider as SeagullDeviceProvider, ScopedThemeProvider, useDevice } from 'seagull';
import { getDefaultTheme } from '~/constants';
import { useRootDevice } from '~/providers/DeviceProvider';
function ScaledDownFontsOnMobile(param) {
    let { children, maxHeight = true } = param;
    const { isMobileDevice } = useDevice();
    return isMobileDevice ? /*#__PURE__*/ _jsx(ScopedThemeProvider, {
        theme: getDefaultTheme('mobile'),
        maxHeight: maxHeight,
        maxWidth: true,
        children: children
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
export function MobileDeviceEnhancer(param) {
    let { children, enabled = true, maxHeight = true } = param;
    const { isMobileDevice } = useRootDevice();
    const value = useMemo(()=>({
            isMobileDevice
        }), [
        isMobileDevice
    ]);
    if (!enabled) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(SeagullDeviceProvider, {
        value: value,
        children: /*#__PURE__*/ _jsx(ScaledDownFontsOnMobile, {
            maxHeight: maxHeight,
            children: children
        })
    });
}
